//Table Header : 조회건수, Search, 엑셀다운로드
//Table Body : 조회목록
//Table Footer : rowsperpage, Pagination

import React, {useEffect, useState} from "react";

import { Box, Grid,Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TableSortLabel, Pagination, Checkbox, } from "@mui/material";

// icon
import IconButton from '@mui/material/IconButton';
import LastPageIcon from '@mui/icons-material/LastPage';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
// style
import { makeStyles } from "@material-ui/core/styles";
import { useTheme } from '@mui/material/styles';

// API
import { fnExcel, fni18n } from "../../services/commonService";
import UButton from "./UButton";
import { useCallback } from "react";

const UTable = (props) => {
    const DEFAULT_ORDER = 'asc';
    const DEFAULT_ORDER_BY = 'calories';
    const DEFAULT_ROWS_PER_PAGE = props.rowPerPage||10;
    let FOOTER_YN = true;
    if(typeof props.footer === "undefined"){
        FOOTER_YN = true;
    }else{
        FOOTER_YN = props.footer;
    }    
    const maxWidth = props.maxWidth; //table 가로 스크롤 생길 시 지정(1600)
    const [order, setOrder] = useState(DEFAULT_ORDER);
    const [orderBy, setOrderBy] = useState(DEFAULT_ORDER_BY);
    const [page, setPage] = useState(1);
    const [rowsperpage, setrowsperpage] = useState(DEFAULT_ROWS_PER_PAGE);
    const [visibleRows, setVisibleRows] = useState([]);
    const [selected, setSelected] = useState(['-1']);
    const [checkItems, setCheckItems] = useState([]);
    const {columns, rows} = props;
    const [checked, setChecked] = useState(false);
    
    const hideCols = columns.filter(column =>column.hide).map(col=>col.field); // hide=true가 포함된 field return
    const filteredColumns = columns.filter(column => !hideCols.includes(column.field)); // hide = true가 포함되지 않은 columns 배열
    const colSpanCols = columns.filter(column=>column.colSpan).map(col=>col.colSpan); // columns 안에 colSpan = [{}] 배열
    const columnLen = columns.length + colSpanCols.reduce(function add(sum, currValue) { // 전체 컬럼 수
        return sum + currValue.length; }, 0);
        
    const useStyles = makeStyles({
        table: {
            "& .MuiTableCell-root": {
                border: "1px solid #EAEAEA",
            }
        },
        header:{
            fontWeight:"bold",
            "& .MuiTableCell-root": {
                // height: '50px',
                backgroundColor: '#F6F6F6',
                fontWeight:"bold",
                fontSize: "0.75rem",
                lineHeight: "1rem",
            },
        },
        subheader:{
            fontWeight:"bold",
            "& .MuiTableCell-root": {
                fontWeight:"bold",
                // paddingLeft: "15px",
                color: "#444444",
                lineHeight: "0",
                fontSize: "0.75rem",
                // height: "20px",
                padding: "0px",
            },
            backgroundColor: "#F6F6F6",
        },
        body:{
            "& .MuiTableCell-root": {
                padding: "0px",
                fontWeight:"400",
                color: "#444444",
                fontSize: "0.75rem",
            },
            height: "45px",
        },
        row:{
            "& .MuiTableCell-root": {
            }
        },
        excelBtn:{
            '&:hover': {
                backgroundColor: '#23A41A',
            },
        }
    });
    const classes = useStyles();

    useEffect(()=>{
        const fetchData = async () => {
            await handleChangePage("", 1);
        };
        fetchData();
    }, [order, orderBy, rows]);

    useEffect(()=>{
        const chkData = async () => {
            props.onCheckedChange && props.onCheckedChange(checkItems);
        };
        chkData();
    }, [checkItems]);

    // useEffect(()=>{
    //     const sortedRows = stableSort(rows, getComparator(order, orderBy));
    //     const updatedRows = sortedRows.slice(
    //       (page-1) * rowsperpage,
    //       (page-1) * rowsperpage + rowsperpage,
    //     );

    //     setVisibleRows(updatedRows);

    //     if(updatedRows.length>0){        
    //     let initSelected = [];
    //     initSelected = initSelected.concat('-1',updatedRows[0].id,);
    //     setSelected(initSelected);
    //     }

    // },[order, orderBy, rows]);

    // Sorting Start >>>>>>
    const handleRequestSort = useCallback( (event, newOrderBy) => {
        const isAsc = orderBy === newOrderBy && order === 'asc';
        const toggledOrder = isAsc ? 'desc' : 'asc';
        setOrder(toggledOrder);
        setOrderBy(newOrderBy);

        const sortedRows = stableSort(rows, getComparator(toggledOrder, newOrderBy));
        const updatedRows = sortedRows.slice(
        (page-1) * rowsperpage,
        (page-1) * rowsperpage + rowsperpage,
        );
        setVisibleRows(updatedRows); 
      }
      ,[order, orderBy, page, rows],
    );

    function stableSort(array, comparator) {
        const stabilizedThis = array.map((el, index) => [el, index]);
        stabilizedThis.sort((a, b) => {
            const order = comparator(a[0], b[0]);
            if (order !== 0) {
            return order;
            }
            return a[1] - b[1];
        });
        return stabilizedThis.map((el) => el[0]);
    }
    
    function getComparator(order, orderBy) {
        return order === 'desc' ? (a, b) => descendingComparator(a, b, orderBy) 
        : (a, b) => -descendingComparator(a, b, orderBy);
        }

    function descendingComparator(a, b, orderBy) {
        if (b[orderBy] < a[orderBy]) {
          return -1;
        }
        if (b[orderBy] > a[orderBy]) {
          return 1;
        }
        return 0;
    }
    // Sorting End <<<<<<


    // Paging Start >>>>>>
    const handleChangePage = React.useCallback((event, newPage) => {
        setPage(newPage);
        const sortedRows = stableSort(rows, getComparator(order, orderBy));
        const updatedRows = sortedRows.slice(
            (newPage-1) * rowsperpage,
            (newPage-1) * rowsperpage + rowsperpage,
        );
        setVisibleRows(updatedRows);

        //selected row
        if(updatedRows.length>0){
            let initSelected = [];
            initSelected = initSelected.concat('-1',updatedRows[0].id,);
            setSelected(initSelected);
        }
    },[order, orderBy, rows]);

    function TablePaginationActions(props) {
        const theme = useTheme();
        const { count, page, rowsperpage, onPageChange } = props;
        const handleFirstPageButtonClick = (event) => {
            onPageChange(event, 0);
        };
        const handleBackButtonClick = (event) => {
            onPageChange(event, page - 1);
        };
        const handleNextButtonClick = (event) => {
            onPageChange(event, page + 1);
        };
        const handleLastPageButtonClick = (event) => {
            onPageChange(event, Math.max(0, Math.ceil(count / rowsperpage) - 1));
        };
        return (
            <Box sx={{ flexShrink: 0, ml: 2.5 }}>
                <IconButton
                    onClick={handleFirstPageButtonClick}
                    disabled={page === 0}
                    aria-label="first page"
                >
                    {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
                </IconButton>
                <IconButton
                    onClick={handleBackButtonClick}
                    disabled={page === 0}
                    aria-label="previous page"
                >
                    {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
                </IconButton>
                <IconButton
                    onClick={handleNextButtonClick}
                    disabled={page >= Math.ceil(count / rowsperpage) - 1}
                    aria-label="next page"
                >
                    {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
                </IconButton>
                <IconButton
                    onClick={handleLastPageButtonClick}
                    disabled={page >= Math.ceil(count / rowsperpage) - 1}
                    aria-label="last page"
                >
                    {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
                </IconButton>
            </Box>
        );
    }
    // Paging End <<<<<<
    // rowsperpage
    // const handleChangerowsperpage = React.useCallback((event) => {
    //     const updatedrowsperpage = parseInt(event.target.value, 10);
    //     setrowsperpage(updatedrowsperpage);
    //     setPage(1);
    //     const sortedRows = stableSort(rows, getComparator(order, orderBy));
    //     const updatedRows = sortedRows.slice(
    //     (page-1) * updatedrowsperpage,
    //     (page-1) * updatedrowsperpage + updatedrowsperpage,
    //     );
    //     setVisibleRows(updatedRows);
      
    //   },[order, orderBy, rows],);
    //header

    // 체크박스
    function onCheckedAll(event){
        var checked = event.target.checked;
        if(checked) {
            const idArray = [];
            visibleRows.forEach((el) => idArray.push(el.id));
            setCheckItems(idArray);
          }
          else {
            setCheckItems([]);
          }
    };
        
      // 체크박스 단일 선택
    const handleSingleCheck = (checked, id) => {
        if (checked) {
            setCheckItems(prev => [...prev, id]);
        } else {
            setCheckItems(checkItems.filter((el) => el !== id));
        }
        //props.onCheckedChange && props.onCheckedChange(checked, id);
    };

      function EnhancedTableHead(props) {
        const { order, orderBy, onRequestSort, columns } = props;
        const createSortHandler = (newOrderBy) => (event) => {
            onRequestSort(event, newOrderBy);
        };
        return (
        <TableHead>
            <TableRow className={classes.header}>{/* 컬럼 */}
                {columns.map((col) => (
                    !col.hide? (
                                <TableCell key={col.field}
                                colSpan={col.colSpan ? col.colSpan.length : null}
                                rowSpan={col.colSpan ? null : 2}
                                sortDirection={orderBy === col.field ? order : false}
                                style={Object.assign({padding:'0px'}, {textAlign:col.headerAlign}, !col.checkBox?{paddingLeft:'18px'}:{}, colSpanCols.length?{height:"23.7px"}:{height:"50px"}, )}
                                >
                                {!col.checkBox? (
                                    <TableSortLabel
                                        active={orderBy === col.field}
                                        direction={orderBy === col.field ? order : 'asc'}
                                        onClick={createSortHandler(col.field)}
                                    >
                                        {fni18n(col.headerName)}
                                    </TableSortLabel>):(<Checkbox onChange={onCheckedAll} checked={checkItems.length === visibleRows.length ? true : false}   />)}
                                </TableCell>):(null)))}
            </TableRow>
            <TableRow className={classes.subheader}>{/* colspan 컬럼 (아랫줄)*/}
                {colSpanCols.map((cols) => (
                    cols.map((col) => (
                        !col.hide?(<TableCell key={col.field}
                            style={Object.assign({padding:'0px'}, {textAlign:col.headerAlign}, !col.checkBox?{paddingLeft:'18px'}:{}, {height:'23.7px'})}>
                                {!col.checkBox? (
                                <TableSortLabel 
                                    active={orderBy === col.field}
                                    direction={orderBy === col.field ? order : 'asc'}
                                    onClick={createSortHandler(col.field)}
                                >
                                    {fni18n(col.headerName)}
                                </TableSortLabel>):(<Checkbox  onChange={onCheckedAll} />)}
                        </TableCell>):(null)))))}
            </TableRow>
        </TableHead>
        );
    }
//<div style={{  borderRadius: "0px", overflowX: "hidden", overflowY: "hidden",}}>
    const handleClick = (event, row) => {
        //const selectedIndex = selected.indexOf(row.id);
        let newSelected = [];
        // 다중선택
        // if (selectedIndex === -1) {
        // newSelected = newSelected.concat(selected, id);
        // } else if (selectedIndex === 0) {
        // newSelected = newSelected.concat(selected.slice(1));
        // } else if (selectedIndex === selected.length - 1) {
        // newSelected = newSelected.concat(selected.slice(0, -1));
        // } else if (selectedIndex > 0) {
        // newSelected = newSelected.concat(
        //     selected.slice(0, selectedIndex),
        //     selected.slice(selectedIndex + 1),
        // );
        // }
        newSelected = newSelected.concat('-1',row.id,);
        setSelected(newSelected);
        props.onSelectedRowChange && props.onSelectedRowChange(event, row);
    };
    const isSelected = (id) => selected.indexOf(id) !== -1;
    const tableHeight = 50 + 45 * rowsperpage + (maxWidth? 21: 4 )

    return(
        <div style={{  borderRadius: "0px"}}>
            <Box  sx={{p:"0px 0px"}}>
                {/* height: 571px  <=  45px * 10 (table) + 2px (header borderTop) + 74ox (paging etc..) */}
                <TableContainer sx={{height: tableHeight || "498.5px", maxWidth: maxWidth, border: "1px solid #EAEAEA", borderTop: "2px solid #2F2F2F", marginBottom: "5px" }}> 
                    <Table className={classes.table}  sx={{height: "max-content"}} >
                        {/* TableHeader - 컬럼명 */}
                        <EnhancedTableHead
                            order={order}
                            orderBy={orderBy}
                            onRequestSort={handleRequestSort}
                            rowCount={props.rows.length}
                            columns={columns}/>
                        {/* TableBody - 조회목록 */}
                        <TableBody>
                            { visibleRows && visibleRows.length> 0 ? ( visibleRows.map(row => {
                                const isItemSelected = isSelected(row.id);
                                return (
                                    <TableRow key={row.id} hover className={classes.body}
                                        aria-checked={isItemSelected}
                                        selected={isItemSelected} onClick={(event) => handleClick(event, row)}
                                        sx={{cursor:'pointer'}}
                                    >
                                        {filteredColumns.map(column => {
                                            // colSpan 있을때
                                            if (column.colSpan) {
                                                return (column.colSpan.map(col => (
                                                            <TableCell style={col.align === 'left'? {paddingLeft:'10px', minWidth:col.width, textAlign:col.align, }
                                                            : col.align==='right'?{paddingRight:'10px', minWidth:col.width, textAlign:col.align, }
                                                            : {textAlign:col.align, minWidth:col.width}} 
                                                            key={col.field}>
                                                                {
                                                                    Object.keys(col).filter(key => typeof col[key] == 'function').length > 0
                                                                    ?Object.keys(col).filter(key => typeof col[key] == 'function').map((k)=>{
                                                                        const params = {
                                                                            'rows' : row,
                                                                            'value' : row[col.field],
                                                                        }
                                                                        return col[k](params)
                                                                    }): !col.checkBox? row[col.field]: <Checkbox  onChange={(e) => handleSingleCheck(e.target.checked, row.id)}
                                                                                                                checked={checkItems.includes(row.id) ? true : false} />
                                                                }
                                                            </TableCell>
                                                        ))
                                                );
                                            } else {
                                                //key값 type이 function인지 확인
                                                let funcArr = Object.keys(column).filter(key => typeof column[key] == 'function');
                                                const params = {
                                                    'rows' : row,
                                                    'value' : row[column.field],
                                                    'checked' : checkItems.includes(row.id) ? true : false,
                                                };
                                                return(
                                                    <TableCell style={column.align === 'left'?{paddingLeft: '10px', minWidth: column.width, textAlign:column.align,}
                                                    : column.align === 'right'? {paddingRight:'10px', minWidth: column.width, textAlign: column.align, }
                                                    : {textAlign: column.align, minWidth: column.width, }} 
                                                    key={column.field}>
                                                        {funcArr.length > 0
                                                            ? funcArr.map((k) => { return column[k](params)})
                                                            :!column.checkBox? fni18n(row[column.field]): <Checkbox  onChange={(e) => handleSingleCheck(e.target.checked, row.id)}
                                                                                                            checked={checkItems.includes(row.id) ? true : false} />
                                                        }
                                                    </TableCell>
                                                );
                                            }
                                        })}
                                    </TableRow>)})
                            ):(<TableRow><TableCell colSpan={columnLen} align="center">{fni18n("검색 결과가 없습니다")}</TableCell></TableRow>)}
                        </TableBody>
                    </Table>
                </TableContainer>
                {FOOTER_YN?(<>
                <Grid container sx={{height: maxWidth? '53px': '72px', alignItems:"center" }} >
                    <Grid item xs={4} >
                        <Typography variant="h7" component="span" sx={{color:"#000", fontSize: "0.8rem"}}> {fni18n("결과")} </Typography>
                        <Typography variant="h7" component="span" sx={{color:"#808080", fontSize: "0.8rem"}}> {fni18n("전체")} </Typography>
                        <Typography variant="h7" component="span" sx={{color:"#8D7C57", fontSize: "0.8rem"}}> {props.rows.length}</Typography>
                    </Grid>
                    <Grid item xs={4}sx={{display:"flex", justifyContent:"center", }}>
                        <Pagination
                            color="primary"
                            variant="text"
                            shape="rounded"
                            count={Math.ceil(rows.length/rowsperpage)}
                            rowsPerPage={rowsperpage}
                            page={!rows.length || rows.length <= 0 ? 0 : page}
                            size="small"
                            showFirstButton
                            showLastButton
                            onChange={handleChangePage}
                            ActionsComponent={TablePaginationActions}
                        />
                    </Grid>
                    <Grid item xs={4} sx={{display:"flex",justifyContent:"right", }}>
                        {props.toolbarAdd}
                        <UButton  isTab color="secondary" icon="Down" onButtonClick={(e)=>fnExcel(columns,rows,e)}>
                            엑셀
                        </UButton>
                    </Grid>
                </Grid>
                </>):(<></>)}
            </Box>
        </div>
    )
}
export default UTable;